import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import { makeStyles } from '@material-ui/core/styles'
import { Theme } from '@material-ui/core/styles/createTheme'
import upperFirst from 'lodash/upperFirst'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { colors } from 'src/theme'

interface IConfirmationDialog {
  action: 'confirm' | 'delete'
  descriptionMessage?: string
  onClose: () => void
  onConfirmation: () => void
  open: boolean
}

const ConfirmationDialog = (props: IConfirmationDialog) => {
  const { open, onClose, onConfirmation, descriptionMessage } = props
  const classes = useStyles()
  const { t } = useTranslation()

  let confirmationButtonText = t('button.confirm')
  let confirmationButtonClassName = classes.confirmButton
  if (props.action === 'delete') {
    confirmationButtonText = t('button.delete')
    confirmationButtonClassName = classes.deleteButton
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth={true}
      maxWidth={'sm'}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{upperFirst(t('are you sure ?'))}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">{descriptionMessage}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button id="cancelButton" onClick={onClose} color="primary">
          {t('button.cancel')}
        </Button>
        <Button
          id="confirmationButton"
          onClick={onConfirmation}
          variant="contained"
          color="primary"
          autoFocus={true}
          className={confirmationButtonClassName}
        >
          {confirmationButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

const useStyles = makeStyles((theme: Theme) => ({
  confirmButton: {
    background: theme.palette.primary.main,
    color: colors.white,
  },
  deleteButton: {
    background: theme.palette.error.main,
    color: colors.white,
  },
}))

export default ConfirmationDialog
